<loren-page-content>
  <mat-card-title>{{ "user.profile" | transloco }}</mat-card-title>
  <div class="loren-user-profile-container">
    <div class="loren-user-profile-main">
      <div>
        <loren-user-profile-picture
          [userInfo]="userInfo()"
          (userInfoUpdated)="updateUserInfo($event)">
        </loren-user-profile-picture>
        <loren-user-profile-details
          [userInfo]="userInfo()"
          (userInfoUpdated)="updateUserInfo($event)">
        </loren-user-profile-details>
      </div>
      @if(smsNotificationsEnabled()) {
      <mat-card *lorenShowForPrivileges="[privileges.WRITE_AUTOMATION_RULES]">
        <loren-key-value
          [key]="'user.sms' | transloco"
          [value]="smsNumber()"></loren-key-value>
      </mat-card>
      }
      <div>
        <loren-user-profile-password></loren-user-profile-password>
      </div>
    </div>
  </div>
</loren-page-content>
